export default {
    baseStyle: (props) => ({
        parts: [],
        container: {
            display: { base: 'grid' },
            gridTemplateColumns: { base: '39px 1fr auto' },
            gap: { base: '16px' },
            mb: { base: 4 },
        },
        icon: {
            textAlign: 'center'
        },
        name: {
            fontSize: { base: 'xs' },
            lineHeight: { base: '16px' },
            letterSpacing: { base: '0' },
            textTransform: { base: 'uppercase' },
            mb: { base: 1 },
            fontWeight: { base: 'medium' }
        },
        typo: {
            fontSize: { base: 'xs' },
            lineHeight: { base: '16px' },
            letterSpacing: { base: '0' }
        },
        costWrapper: {
            mt: { base: 2 },
            mb: { base: 4 }
        },
        cost: {
            fontSize: { base: 'xs' },
            lineHeight: { base: '16px' },
            textTransform: { base: 'uppercase' },
            letterSpacing: { base: '0' },
            fontWeight: { base: 'medium' }
        }
    })
}
